/* global axios */

// Prévia de voz. Passa pelo axios do painel (que leva os cabeçalhos de login):
// o endpoint exige usuário logado desde 10/2026 — um fetch cru recebe 401.
export default {
  preview({ voice, provider, text }) {
    return axios.post(
      '/api/v1/tts/preview',
      { voice, provider, text },
      { responseType: 'blob' }
    );
  },
};

const readBlobText = blob =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error);
    reader.readAsText(blob);
  });

// Com responseType 'blob', o corpo do erro também chega como Blob.
export const previewErrorMessage = async error => {
  const data = error?.response?.data;
  if (!(data instanceof Blob)) return null;
  try {
    return JSON.parse(await readBlobText(data))?.error || null;
  } catch {
    return null;
  }
};
